<template>
  <div class="topNav">
    <div
      class="btn_item pointer"
      v-for="item in showList"
      :key="item.type"
      @click="handleBtnClick(item.type)"
    >
      {{ item.label }}
    </div>
  </div>
</template>

<script>
import { getAccessToken } from '@/utils/userInfo'
import { openOther } from '@/utils'

export default {
  data () {
    return {
      activeType: 1
    }
  },
  computed: {
    btnList () {
      // 判断是否是企业站用户
      if (this.$store.state.user.corpUserInfo.customerId) {
        return [
          { label: '全部商品', type: 101 },
          { label: '协议商品', type: 102 },
          // { label: "常购商品", type: 103 },
          { label: '集团协议商品', type: 104 }
        ]
      } else {
        return [
          { label: '首页', type: 1 },
          // { label: "精品商城", type: 8, hide: false },
          { label: '联储联备', type: 2, hide: false }
          // { label: "场景化采购", type: 3, hide: false },
          // { label: "知识培训", type: 4, hide: false },
          // { label: "解决方案", type: 5, hide: false },
          // { label: "工业SaaS", type: 6, hide: false },
          // { label: "生态服务", type: 7 },
          // { label: "优选品类", type: 9, hide: false },
          // { label: "渠道商", type: 10, hide: !this.isPlcShow },
          // { label: "内容资讯", type: 11, hide: false },
        ]
      }
    },
    ecology () {
      return this.$store.state.ecology
    },
    isEcologicalShow () {
      return this.ecology && [1, 2].includes(+this.ecology.userInfo.userType)
    },
    isPlcShow () {
      return this.ecology && [true].includes(this.ecology.plcUserInfo)
    },
    showList () {
      return this.btnList.filter((item) => !item.hide)
    }
  },
  created () {
    this.checkIsViewPlc() // 先注释
  },
  methods: {
    handleBtnClick (type) {
      this.activeType = type
      switch (type) {
        case 1:
          this.routerHandle('home')
          break
        case 2:
          this.routerHandle('storeSpare')
          break
        case 3:
          this.routerHandle('shopping-scene-purchase')
          break
        case 4:
          this.routerHandle('onlineTraining')
          break
        case 5:
          this.routerHandle('planList')
          break
        case 6:
          this.routerHandle('saasIndex')
          break
        case 7:
          this.routerHandle('ecologicalServices-join')
          break
        case 8:
          window.open('/premium')
          break
        case 9:
          window.open('/preferredBrand')
          break
        case 10:
          sessionStorage.setItem(
            'plcUserInfo',
            JSON.stringify(this.$store.state.user)
          )
          window.open('/plc')
          sessionStorage.remove('plcUserInfo')
          break
        case 11:
          window.open('/contentInfo/contentInfo')
          break
        case 101:
          this.routerHandle('home')
          break
        case 102:
          this.routerHandle('corpWebsite-agreedGoods')
          break
        case 103:
          this.routerHandle('corpWebsite-boughtGoods')
          break
        case 104:
          this.routerHandle('corpWebsite-groupAgreedGoods')
          break
        default:
          break
      }
    },
    routerHandle (name) {
      if (name === 'rdms') {
        if (getAccessToken() && this.$store.state.user.jwtStr) {
          openOther(
            window.SITE_CONFIG['rdmsUrl'] + this.$store.state.user.jwtStr,
            true
          )
        } else {
          this.$router.push({
            name: name
          })
        }
      } else if (['storeSpare', 'demandManage'].includes(name)) {
        if (!getAccessToken()) {
          // this.$router.push({
          //   name: 'login'
          // })
          this.bus.$emit('showLoginDialog')
        } else {
          this.$router.push({
            name: name
          })
        }
      } else if (name) {
        this.$router.push({
          name: name
        })
      }
    },
    checkIsViewPlc () {
      if (!getAccessToken()) {
        return
      }
      const obj = {
        defaultCompanyId: this.$store.state.user.defaultCompanyId + '' || ''
      }
      this.$http
        .post('/front/oms/plc/user/checkIsViewPlc', obj)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.$store.commit('setPlcUserInfo', res.data)
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.topNav {
  display: flex;
  margin: 16px 0;
  padding: 0 8px;
  .btn_item {
    font-family: Alibaba PuHuiTi;
    font-size: 16px;
    // font-weight: 700;
    line-height: 16px;
    text-align: center;
    color: #333333;
    padding: 4px 8px;
    margin-right: 8px;
    &:last-child {
      margin-right: 0;
    }
    &:hover {
      color: #2a54d1;
      background: #f5f6fa;
    }
  }
}
</style>
